export const DESKTOP_SCREEN_WIDTH = "1060px"